module.exports = __webpack_public_path__ + "img/Group.a62ab000.svg";